import React from 'react'
import { Box, Grid, Link, Typography } from '@material-ui/core'

import useStyles from './styles'
import constants from 'constants/index'

const PhishingTutorial = () => {
  const classes = useStyles()

  return (
    <Grid container spacing={2}>
      {constants.phishing.TUTORIAL_CARDS.map((card, index) => (
        <Grid key={index} item xs={12} md={6}>
          <Box className={classes.card}>
            <Box className={classes.header}>
              <Box className={classes.numberBox}>
                <Typography variant="h6">{index + 1}</Typography>
              </Box>
              <Typography variant="h5">{card.title}</Typography>
            </Box>
            <Typography variant="body2">{card.description}</Typography>
            {index === 1 && (
              <Box display="flex" flexDirection="column" gridGap={4}>
                {constants.phishing.ALLOWLIST_GUIDES.map(({ label, href }) => (
                  <Link
                    key={label}
                    href={href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={classes.guideLink}
                    variant="body2"
                  >
                    {'• '}
                    {label}
                  </Link>
                ))}
              </Box>
            )}
          </Box>
        </Grid>
      ))}
    </Grid>
  )
}

export default PhishingTutorial
